export default __webpack_public_path__ + "static/media/panner_bg.32c41509.svg";